module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.442614c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-Regular.svg
// module id = 225
// module chunks = 0